import React, { memo } from "react";
import styles from "./TaskItem.module.css";
import { ProgressBar } from "../../../../Components/ProgressBar/ProgressBar";
import {
  TaskButton,
  TaskButtonVariant,
} from "../../../../Components/TaskButton/TaskButton";
import { useAdaptiveText } from "../../../../hooks/useAdaptiveText";
import { Reward } from "../../../../Components/Reward/Reward";
import { TaskItemProps } from "./TaskItemBase";

export const IndividualTaskItem: React.FC<TaskItemProps> = memo(
  ({ task, onTaskAction }) => {
    const { truncateText, measureRef } = useAdaptiveText({
      maxWidthAtLargeScreen: 250,
      maxWidthAtSmallScreen: 150,
      largeScreenWidth: 500,
      smallScreenWidth: 370,
    });

    console.log("🎯 IndividualTaskItem rendering with task:", task.id);

    const getButtonProps = () => {
      console.log("🔄 Getting button props for status:", task.status);
      const baseProps = {
        task,
        variant: task.status as TaskButtonVariant,
        onClick: onTaskAction ? () => onTaskAction(Number(task.id)) : undefined,
        text: "",
      };

      switch (task.status) {
        case "WAITING":
          return {
            ...baseProps,
            variant: "WAITING" as TaskButtonVariant,
            text: task.buttonText || "Проверка",
          };
        case "CLAIMED":
          if (
            task.link &&
            task.link !== "" &&
            task.link !== "-" &&
            task.provider === "PARTNERS"
          ) {
            return {
              ...baseProps,
              variant: "CLAIMED_WITH_LINK" as TaskButtonVariant,
              text: "",
              link: task.link,
            };
          }
          return {
            ...baseProps,
            variant: "CLAIMED" as TaskButtonVariant,
            text: "Выполнено",
          };
        case "DONE":
          return {
            ...baseProps,
            variant: "DONE" as TaskButtonVariant,
            text: "Собрать",
          };
        case "NOT_STARTED":
          return {
            ...baseProps,
            variant: "NOT_STARTED" as TaskButtonVariant,
            text: task.buttonText || "Подписаться",
          };
        case "IN_PROGRESS":
          return {
            ...baseProps,
            variant: "DONE" as TaskButtonVariant,
            text: "Собрать",
          };
        default:
          return baseProps;
      }
    };

    const fullClick = () => {
      if (
        task.provider === "PARTNERS" &&
        task.status === "CLAIMED" &&
        task.link
      ) {
        window.Telegram.WebApp.openTelegramLink(task.link);
      }
    };

    const handleFindEmoji = (title: string) => {
      // Регулярное выражение для проверки эмодзи
      const emojiRegex = /^\p{Extended_Pictographic}$/u;

      const chars = Array.from(title);
      // Проверяем по циклу, если символ - не эмодзи, значит возвращаем его
      for (let char of chars) {
        if (!emojiRegex.test(char)) {
          return char;
        }
      }
      return;
    };

    return (
      <div className={styles.taskItem} onClick={fullClick}>
        <span
          ref={measureRef}
          style={{ visibility: "hidden", position: "absolute" }}
        />
        <div className={styles.cardContent}>
          <div className={styles.cardImage}>
            {task.icon === "" || !task.icon.includes("http") ? (
              <div
                className={
                  task.type === "quest-daily" ? styles.dailyIcon : styles.dummy
                }
              >
                {handleFindEmoji(task.title)}
              </div>
            ) : (
              <>
                <img
                  src={task.icon}
                  alt={task.title}
                  className={
                    task.type === "quest-daily" ? styles.dailyIcon : styles.icon
                  }
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    const nextElement = e.currentTarget
                      .nextElementSibling as HTMLElement;
                    if (nextElement) {
                      nextElement.style.display = "flex";
                    }
                  }}
                />
                <div
                  className={
                    task.type === "quest-daily"
                      ? styles.dailyIcon
                      : styles.dummy
                  }
                  style={{ display: "none" }}
                >
                  {handleFindEmoji(task.title)}
                </div>
              </>
            )}
          </div>
          <div className={styles.taskContent}>
            <h4 className={styles.taskTitle} title={task.title}>
              <span
                ref={measureRef}
                style={{ visibility: "hidden", position: "absolute" }}
              >
                {task.title}
              </span>
              {truncateText(task.title)}
            </h4>
            {(task.provider !== "PARTNERS" || task.status !== "CLAIMED") && (
              <div className={styles.rewards}>
                <Reward type="dc" amount={task.rewards?.dc ?? 0} />
                <Reward type="ticket" amount={task.rewards?.tickets ?? 0} />
              </div>
            )}
            {task.provider === "PARTNERS" && task.status === "CLAIMED" && (
              <div
                className={
                  styles.rewardsText +
                  " " +
                  (task.is_subscribed === false
                    ? styles.rewardsTextSubscribed
                    : "")
                }
              >
                {task.is_subscribed === false
                  ? "Нет подписки"
                  : task.status === "CLAIMED"
                  ? "Награда получена"
                  : null}
              </div>
            )}
          </div>
        </div>
        {task.status !== "DONE" &&
          task.progress?.total &&
          task.progress.total > 1 &&
          task.progress?.total !== task.progress?.current && (
            <ProgressBar
              current={task.progress.current}
              total={task.progress.total}
              showText={true}
              showProgress={false}
            />
          )}
        {(task.status === "DONE" ||
          (task.progress?.total && task.progress.total <= 1) ||
          task.progress?.total === task.progress?.current) && (
          <div className={styles.taskButtonContainer}>
            <TaskButton {...getButtonProps()} />
          </div>
        )}
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.task.id === nextProps.task.id &&
      prevProps.task.status === nextProps.task.status
    );
  }
);
